export default __webpack_public_path__ + "static/media/twitter.da287da4.svg";